import { useAtom } from 'jotai';
import React, { useCallback } from 'react';
import atoms from '../utils/atoms';
import handleNoOp from "../utils/handleNoOp"

function Sort(props) {

    const [, setForm] = useAtom(atoms.form)
  
    const handleChange = useCallback(e => setForm(form => { form.sort = e.target.value }), [setForm])

    return (
        <div className="no-wrap d-inline-block">
            <form onSubmit={handleNoOp} className="">
                <label className="mr-2" htmlFor="sort">Sort By</label>
                <select className="form-control" name="sort" id="sort" onChange={handleChange} style={{background: "white", display: "inline-block", width: "auto",}}>
                    <option value="a-z" key="a-z" >Title (A to Z)</option>
                    <option value="z-a" key="z-a">Title (Z to A)</option>
                </select>
            </form>
        </div>
    );
}
export default Sort;